import _extends from "/src/main/react/node_modules/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/src/main/react/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _jsxFileName = "/src/main/react/src/main/app/components/login/LoginForm.js";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input from '@material-ui/core/OutlinedInput';
import { Grid, Button, Typography, CircularProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { withCookies } from 'react-cookie';
import { LOCAL_STORAGE_ITEM_NAMES, SESSION_STORAGE_ITEM_NAMES, TPIC_RESP_HEADERS, TPIS_CAPABILITIES } from "../domain/constants";
import { HOMEPAGE } from "../Routes";
import Util from '../../util/Util';
import { digestMessage, generateRandomPassword, hexString } from "../../util/PasswordUtil";
import { determineSelectedPartner } from "../../util/StorageUtil";
import { isNotABlankString, listToString, objToString } from "../../util/StringUtil";
const styles = {};
class LoginForm extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleChange", name => event => {
      this.setState({
        [name]: event.target.value
      });
    });
    _defineProperty(this, "renderError", () => {
      if (this.state.failure) {
        const errmsg = this.state.failure;
        return /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          color: "error",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 55,
            columnNumber: 17
          }
        }, errmsg);
      }
    });
    _defineProperty(this, "handleSubmit", async event => {
      event.preventDefault();
      sessionStorage.removeItem(SESSION_STORAGE_ITEM_NAMES.CSRFTOKEN);
      this.state.loginProcessing = true;
      this.state.failure = null;
      this.forceUpdate();
      const data = new FormData(this.form);
      const csrfToken = await this.csrfToken();
      data.append('csrfToken', csrfToken);
      fetch('/perform_login', {
        method: 'POST',
        body: new URLSearchParams(data),
        credentials: 'include'
      }).then(v => {
        if (v != null && v.status !== 200) {
          if (v.status === 401) {
            this.state.failure = "Invalid username or password";
          } else if (v.status >= 500) {
            this.state.failure = "Internal error while attempting to log in";
          } else {
            this.state.failure = "Login unsuccessful";
          }
          this.state.loginProcessing = false;
          this.state.password = '';
          this.forceUpdate();
          return;
        }

        // Store user info in localStorage
        // Should be safe because any TPIS requests will require
        // a valid token anyway. Changing your role shouldn't affect what TPIS returns
        let user = v.headers.get(TPIC_RESP_HEADERS.username);
        if (user) localStorage.setItem(LOCAL_STORAGE_ITEM_NAMES.username, user);

        // Grab myriad base url from the spring response because properties are way easier in java
        let myriadBaseUrl = v.headers.get(TPIC_RESP_HEADERS.myriadBaseUrl);
        localStorage.setItem(LOCAL_STORAGE_ITEM_NAMES.myriadBaseUrl, myriadBaseUrl);
        sessionStorage.setItem(SESSION_STORAGE_ITEM_NAMES.CSRFTOKEN, csrfToken);
        let impersonationAllowed = v.headers.get(TPIC_RESP_HEADERS.impersonationAllowed);
        sessionStorage.setItem(SESSION_STORAGE_ITEM_NAMES.IMPERSONATION_ALLOWED, impersonationAllowed);
        return v.json();
      }).then(resp => {
        if (resp != null) {
          let role = resp.role;
          if (role) localStorage.setItem(LOCAL_STORAGE_ITEM_NAMES.role, role);
          let capabilities = resp.capabilities;
          if (capabilities == null) {
            let failure = "Could not determine capabilities for user account";
            Util.log("LoginForm.handleSubmit", false, failure, true);
            this.state.failure = failure;
          } else {
            this.determineCapabilities(capabilities);
          }
          let partners = resp.visiblePartnerIdentifiers;
          if (partners) localStorage.setItem(LOCAL_STORAGE_ITEM_NAMES.partners, objToString(partners));
          let specialSelectionRules = resp.specialSelectionRules;
          if (specialSelectionRules != null && Array.isArray(specialSelectionRules) && specialSelectionRules.length > 0) {
            const specialSelectionRulesString = listToString(specialSelectionRules);
            localStorage.setItem(LOCAL_STORAGE_ITEM_NAMES.specialSelectionRules, specialSelectionRulesString);
          }
          let partnerOwnerId = resp.partnerOwnerId;
          if (partnerOwnerId != null) {
            localStorage.setItem(LOCAL_STORAGE_ITEM_NAMES.partnerOwnerId, partnerOwnerId);
          }
          let defaultSpecialSelectionRule = resp.defaultSpecialSelectionRule;
          if (defaultSpecialSelectionRule != null && defaultSpecialSelectionRule !== '') localStorage.setItem(LOCAL_STORAGE_ITEM_NAMES.defaultSpecialSelectionRule, defaultSpecialSelectionRule);
          let defaultAspectRatio = resp.defaultAspectRatio;
          // for some reason this value can literally be the word "null" as a string
          if (defaultAspectRatio != null && defaultAspectRatio !== '' && defaultAspectRatio !== 'null') localStorage.setItem(LOCAL_STORAGE_ITEM_NAMES.defaultAspectRatio, defaultAspectRatio);
          let selectedPartner = determineSelectedPartner(partners);
          if (selectedPartner == null) {
            let failure = "Could not determine a default partner value";
            Util.log('LoginForm.handleSubmit', false, failure, true);
            this.state.failure = failure;
          } else {
            this.state.localStorageSet = true;
            this.routeChange();
          }
        }
      }).catch(e => {
        Util.log('LoginForm.handleSubmit', false, e.toString(), true);
        this.state.failure = e.toString();
      });
      this.forceUpdate();
    });
    this.state = {
      failure: null,
      username: '',
      password: '',
      loginProcessing: false,
      localStorageSet: false
    };
  }
  routeChange() {
    let path = HOMEPAGE;
    let search = '';
    const location = this.props.location;
    if (location != null && location.state != null) {
      path = location.state.targetPathName;
      search = location.state.targetSearch;
    }
    this.props.history.push({
      pathname: path,
      search: search
    });
  }
  render() {
    const errors = this.renderError();
    const loginProcessing = this.state.loginProcessing;
    return /*#__PURE__*/React.createElement("form", _extends({}, this.props, {
      onSubmit: this.handleSubmit,
      ref: fm => {
        this.form = fm;
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 65,
        columnNumber: 13
      }
    }), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "column",
      alignItems: "center",
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 68,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 69,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Input, {
      value: this.state.username,
      onChange: this.handleChange('username'),
      fullWidth: true,
      labelWidth: 0,
      placeholder: "username",
      name: "username",
      type: "text",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70,
        columnNumber: 25
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 74,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Input, {
      value: this.state.password,
      onChange: this.handleChange('password'),
      fullWidth: true,
      labelWidth: 0,
      placeholder: "password",
      name: "password",
      type: "password",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 75,
        columnNumber: 25
      }
    })), errors, loginProcessing && /*#__PURE__*/React.createElement(CircularProgress, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 80,
        columnNumber: 41
      }
    }), !loginProcessing && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 82,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Button, {
      label: "Submit",
      type: "submit",
      variant: "contained",
      color: "primary",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 83,
        columnNumber: 25
      }
    }, "Submit"))));
  }
  async csrfToken() {
    const password = await generateRandomPassword();
    const passwordArray = await digestMessage(password);
    return hexString(passwordArray).toUpperCase();
  }
  componentWillUnmount() {
    if (this.state.loginProcessing) {
      while (!this.state.localStorageSet) {
        // noop, just wait for it to set
      }
    }
  }
  determineCapabilities(capabilities) {
    const caps = [];
    const tpisCapsKeyNames = Object.keys(TPIS_CAPABILITIES);
    for (let c of capabilities) {
      for (let t of tpisCapsKeyNames) {
        const cap = TPIS_CAPABILITIES[t];
        if (cap === c) {
          caps.push(cap);
          break;
        }
      }
    }
    localStorage.setItem(LOCAL_STORAGE_ITEM_NAMES.capabilities, listToString(caps));
  }
}
LoginForm.propTypes = {
  name: PropTypes.string,
  action: PropTypes.string,
  method: PropTypes.string,
  inputs: PropTypes.array,
  error: PropTypes.string
};
export default withStyles(styles)(withRouter(withCookies(LoginForm)));